<template>
  <el-table
    :data="changeHistData"
    height='100%'
    style="width: 100%"
  >
    <el-table-column
      v-for="column in changeHistColums"
      :key="column.prop"
      :prop="column.prop"
      :label="column.label"
      :width="column.width"
      :align="column.align"
      :header-align="column.headerAlign"
      show-overflow-tooltip
      >
      <template slot-scope="scope">
        <!-- <span v-if="column.scopedSlot === 'chngHistType-slot'">{{getValueByFormatter(scope, scope.column.prop, scope.column.formatter)}}</span>
        <span v-else-if="column.scopedSlot === 'changeMessage-slot'">{{getValueByFormatter(scope.row, scope., scope.column.formatter)}}</span>
        <span v-else-if="column.scopedSlot === 'checkDatetime-slot'">{{getValueByFormatter(scope.row, column.prop, column.formatter)}}</span> -->
        <div v-if="column.scopedSlot === 'remoteDevice-slot'">
          <span v-if="scope.row.histType === 'U'">
            <p>{{isEmpty(scope.row.prevIpaddress) ? '-': scope.row.prevIpaddress}}</p>
            <p style="text-align: center;">
              <i class="fas fa-arrow-down"></i>
              <span style="position: absolute; opacity: 0;"> -> </span>  <!-- 툴팁에 화살표 표현을 위해서 -->
            </p>
            <p>{{scope.row.remoteIpaddress}}</p>
          </span>
          <span v-else>
            {{scope.row.remoteIpaddress}}
          </span>
        </div>
        <span v-else>{{getValueByFormatter(scope.row, column.prop, column.formatter)}}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { RELATIONSHIP_INFO } from '@/constants/topologymap-major-info';
import { getDateToString } from '@/utils/date';
import { isEmpty } from 'lodash';

export default {
  name: 'WChangeHistTable',
  props: {
    isObj: {
      type: Boolean,
      default: false,
    },
    objectType: {
      type: String,
      default: 'DEVICE',
    },
  },
  data() {
    return {
      isEmpty,
      RELATIONSHIP_INFO,
      getDateToString,
      changeHistData: [],
    };
  },
  computed: {
    changeHistColums() {
      let columns = [{ prop: '', label: '', columnKey: '', scopedSlot: '' }];
      columns = RELATIONSHIP_INFO.CHANGE_HIST[this.objectType] || [];
      return columns;
    },
  },
  methods: {
    setData(data) {
      this.changeHistData = data;
    },
    getValueByFormatter(row, key, formatter) {
      let returnValue = null;
      if (formatter === 'checkDatetime') {
        returnValue = getDateToString(row[key], 'YYYY-MM-DD hh:ss');
      } else if (formatter === 'histType') {
        if (row[key] === 'I') {
          returnValue = '신규';
        } else if (row[key] === 'U') {
          returnValue = '변경';
        } else if (row[key] === 'D') {
          returnValue = '제거';
        }
      } else if (formatter === 'changeMessage') {
        if (row.histType === 'I') {
          returnValue = `${row.localDeviceName}에 ${isEmpty(row.remoteDeviceName) ? '-' : row.remoteDeviceName}이 추가 되었습니다.`;
        } else if (row.histType === 'U') {
          returnValue = `${row.localDeviceName}에 ${isEmpty(row.remoteDeviceName) ? '-' : row.remoteDeviceName}로 변경 되었습니다.`;
        } else if (row.histType === 'D') {
          returnValue = `${row.localDeviceName}에 ${isEmpty(row.remoteDeviceName) ? '-' : row.remoteDeviceName}가 삭제 되었습니다.`;
        }
      } else {
        returnValue = isEmpty(row[key]) ? '-' : row[key];
      }
      return returnValue;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/major-info/components/ChangeHistTable.vue